// Portais cujo cadastro de proposta já está pronto e validado no sistema web.
// Lista de permissão: qualquer portal fora dela (e fora dos restritos abaixo) fica
// bloqueado — Licitar Digital, Publinexo e os próximos.
// 1 = ComprasNet | 2 = Licitações-e legado (BB1) | 4 = PCP | 5 = BLL | 7 = Licitanet | 8 = BNC | 9 = ComprasBR
// (2, 7 e 9 liberados para todos em 18/10/2026, depois da validação do time)
export const PORTAIS_CAD_PROPOSTA_WEB = [1, 2, 4, 5, 7, 8, 9];

// Portais em homologação: o cadastro de proposta só abre para os CNPJs listados
// (conta de testes), ex.: 7: ['52386933000162']. Hoje vazio. Para liberar geral: mover o id
// para PORTAIS_CAD_PROPOSTA_WEB.
// ATENÇÃO: a API tem a mesma lista (PortaisCadPropostaHelper.cs) e recusa as chamadas
// de outros CNPJs — ao liberar/ajustar, alterar os DOIS lugares.
export const PORTAIS_CAD_PROPOSTA_RESTRITOS = {
  10: ['52386933000162'], // Licitar Digital: via bridge, em homologação (18/10/2026)
  11: ['52386933000162'], // AMM Licita: mesmo sistema do Licitar Digital (22/10/2026); abre a tela do LD, liberação própria
  12: ['52386933000162'], // Publinexo: em homologação (18/10/2026)
  13: ['52386933000162', '04956527000145'], // BBMNET: em homologação (18/10/2026); 04956527000145 = outro CNPJ com login de teste (31/10/2026)
};

export const MSG_CAD_PROPOSTA_INDISPONIVEL =
  'O cadastro de proposta deste portal ainda não está disponível no sistema web. Cadastre a proposta direto no portal.';

export const MSG_CAD_PROPOSTA_BB2_INDISPONIVEL =
  'O cadastro de proposta do Licitações-e 2.0 (BB2) está em homologação e ainda não foi liberado para a sua empresa. Cadastre a proposta direto no portal.';

// Licitações-e 2.0 (BB2): cadastro de proposta liberado em homologação (21/10/2026) só para o CNPJ de testes. Lista PRÓPRIA
// porque o BB2 usa o mesmo idportal (2) do legado, que já é liberado para todos.
// ATENÇÃO: a API tem a mesma lista (PortaisCadPropostaHelper.Bb2Liberado) — ao liberar/ajustar, alterar os DOIS lugares.
export const BB2_CAD_PROPOSTA_CNPJS = ['52386933000162'];

// O idportal 2 reúne DUAS plataformas do Banco do Brasil, com o mesmo plano/licença: o que as distingue é o nome do
// portal gravado na licitação (DADOS.licitacoes.nomeportal, copiado para pregoes.nomeportal):
// 'Licitações-e' = BB1 (legado) e 'Licitações-e 2.0' = BB2.
export const ehLicitacoesE2 = (idportal, nomeportal) =>
  Number(idportal) === 2 && String(nomeportal ?? '').includes('2.0');

export const msgCadPropostaIndisponivel = (idportal, nomeportal) =>
  ehLicitacoesE2(idportal, nomeportal) ? MSG_CAD_PROPOSTA_BB2_INDISPONIVEL : MSG_CAD_PROPOSTA_INDISPONIVEL;

const soDigitos = (v) => String(v ?? '').replace(/\D/g, '');

// `cnpj` = CNPJ da empresa ativa (store.getters.cnpjAtivo), usado só nos portais restritos.
// `nomeportal` = nome gravado na licitação: separa o Licitações-e 2.0 (BB2, em homologação: só o CNPJ de testes) do legado.
export const portalTemCadPropostaWeb = (idportal, cnpj = '', nomeportal = '') => {
  const id = Number(idportal);
  if (ehLicitacoesE2(id, nomeportal)) return BB2_CAD_PROPOSTA_CNPJS.includes(soDigitos(cnpj));
  if (PORTAIS_CAD_PROPOSTA_WEB.includes(id)) return true;

  const permitidos = PORTAIS_CAD_PROPOSTA_RESTRITOS[id];
  return !!permitidos && permitidos.includes(soDigitos(cnpj));
};
